import { ReactNode, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Constants from '../../utils/Constants';

const Modal = ({
  id,
  isOpen,
  onClose,
  children,
  primaryColor,
  secondaryColor,
}: {
  id: string;
  isOpen: boolean;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
  children: ReactNode;
  primaryColor: string;
  secondaryColor: string;
}) => {
  useEffect(() => {
    if (!isOpen) {
      return;
    }

    document.body.classList.add('lock_scroll');

    return () => {
      document.body.classList.remove('lock_scroll');
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return ReactDOM.createPortal(
    <div id={id} className='modal' style={{ background: `${primaryColor}` }}>
      <div
        className='modal_close opacity_transition_low'
        onClick={() => {
          onClose(false);
        }}
      >
        {Constants.close(secondaryColor)}
      </div>
      {children}
    </div>,
    document.body
  );
};

export default Modal;
